'use client'

interface DevHelperConsoleProps {
  data: any
}

export default function DevHelperConsole({data}:DevHelperConsoleProps) {
  console.log(data)
  return null
}